<template>
    <div>
        <div v-if="$page.props.flash.success && show" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ $page.props.flash.success }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true" @click="show = false">&times;</span>
            </button>
        </div>
        <div v-if="$page.props.flash.warning && show" class="alert alert-warning alert-dismissible fade show" role="alert">
          {{ $page.props.flash.warning }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true" @click="show = false">&times;</span>
          </button>
        </div>
        <div v-if="$page.props.flash.error && show" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{ $page.props.flash.error }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true" @click="show = false">&times;</span>
          </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hideErrors: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            show: true,
        }
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.show = true
            },
            deep: true,
        },
    }
}
</script>
